// 這是Webpack掛載起始點
import Layout from './layout.vue'
import Index from './index.vue'
import New from '../.components/new.vue'
import Edit from '../.components/edit.vue'

const main_router = 'driver_commission_policies'
const new_router = 'new_driver_commission_policy'
const edit_router = 'edit_driver_commission_policy'

const router = [
    {
        path: '',
        component: Index,
        name: 'driver_commission_policies',
        meta: {
            api_name: 'api_v1_provider_driver_commission_policies',
            breadcrumb: [main_router],
            btns: [new_router]
        }
    },
    {
        path: 'new',
        component: New,
        name: 'new_driver_commission_policy',
        meta: {
            api_name: 'api_v1_provider_driver_commission_policy_create',
            breadcrumb: [main_router, new_router]
        }
    },
    // {
    //     path: ':identity/edit',
    //     component: Edit,
    //     name: 'edit_driver_commission_policy',
    //     meta: {
    //         api_name: '',
    //         breadcrumb: [main_router, edit_router]
    //     }
    // },
]

export default router
